import type { CouponAction, CouponState } from './actions/types';

export const initialCouponState: CouponState = {
    loading: {
        remove: false,
        add: false,
    },
};

export const couponReducer = (state: CouponState, action: CouponAction): CouponState => {
    if (action.type === 'SET_LOADING') {
        const { type, value } = action.payload;
        return {
            ...state,
            loading: {
                ...state.loading,
                [type]: value,
            },
        };
    }

    return state;
};
